import { DeleteOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Popconfirm, Tooltip } from 'antd'
import React from 'react'

export function DeleteActionCellRenderer({ params, createHandleDelete, hasEdits }) {
  if (params.node.group) return null
  const product_group = params.data?.product_group
  const isDefaultProductGroup = product_group === 'default'

  const handleDelete = createHandleDelete(params)

  const renderButton = (tooltip, disabled) => (
    <Horizontal justifyContent='center' verticalCenter>
      <Tooltip title={tooltip}>
        <GraviButton icon={<DeleteOutlined />} style={{ maxHeight: '24px' }} disabled={disabled} />
      </Tooltip>
    </Horizontal>
  )

  if (hasEdits) {
    return renderButton('Save or discard edits before deleting record.', true)
  }

  if (isDefaultProductGroup) {
    return renderButton('Cannot delete default dwell time', true)
  }

  return (
    <Horizontal justifyContent='center' verticalCenter style={{ overflow: 'visible' }}>
      <Popconfirm title='Delete this record?' onConfirm={handleDelete} okText='Confirm'>
        <GraviButton style={{ maxHeight: '24px' }} icon={<DeleteOutlined />} error />
      </Popconfirm>
    </Horizontal>
  )
}
